<template>
  <div class="o-category-card mb-6">
    <base-link
      class="o-category-card__link"
      :link="category.url"
    >
      <base-image
        v-if="image.url"
        class="o-category-card__picture"
        :url="image.url"
        :alt-text="category.name"
        :width="width"
        :height="height"
        :ratio="width/height"
      />
      <div v-else class="o-category-card__nopicture" :style="aspectStyle" />
      <div class="o-category-card__overlay">
        <div class="o-category-card__headline">
          {{ category.name }}
        </div>
        <div class="o-category-card__cta">
          {{ $t('SeeMore', 'Se mere') }}
        </div>
      </div>
    </base-link>
  </div>
</template>

<script>
import BaseImage from '@/components/atoms/BaseImage'
import BaseLink from '@/components/atoms/BaseLink'

export default {
  name: 'CategoryCard',
  components: {
    BaseLink,
    BaseImage
  },
  props: {
    category: {
      type: Object,
      default () {
        return {};
      },
      required: true
    },
  },
  data () {
    return {
      width: 442,
      height: 442
    }
  },
  computed: {
    placeholder () {
      return this.$store.getters['site/getPlaceholder'];
    },
    image () {
      return this.category?.image?.url && this.category?.image?.url.length ? this.category.image : this.placeholder;
    },
    computedAspectRatio () {
      return Number( (this.width/this.height) );
    },
    aspectStyle  () {
      return this.computedAspectRatio
        ? { paddingBottom: (1 / this.computedAspectRatio) * 100 + '%' }
        : undefined;
    }
  }
};
</script>
